export default {"src":"/_next/static/media/Close-white.d5b19c59.svg","height":31,"width":31};